<template>
  <div class="uk-modal-dialog uk-modal-body uk-margin-auto-vertical form">
    <Form @submit="onBeforeSubmit" :validation-schema="validationSchema" ref="form" :initial-values="privacyPolicy">
      <div class="uk-modal-header form-header">
        <label class="uk-text-bold uk-text-large">アセスメントサーベイ受検結果の閲覧範囲について（{{ language }}）</label>
      </div>
      <div class="uk-modal-header form-header">
        <label class="uk-text-bold uk-text-danger">※一度登録された内容の編集は可能ですが、削除はできません</label>
      </div>
      <div class="uk-modal-body">
        <FormError :errors="globalErrors" />
        <div class="field">
          <Field name="policy" v-slot="{ field }">
            <FieldLabel title="受検結果の閲覧範囲" :required="true" />
            <textarea class="uk-textarea" rows="7" v-bind="field" />
            <FieldError name="policy" />
          </Field>
          <Field name="contactName" v-slot="{ field }">
            <div class="uk-flex uk-margin-small-top">
              <FieldLabel title="問い合わせ先" :required="true" />
              <input class="uk-input uk-margin-small-left" type="text" v-bind="field" />
            </div>
            <FieldError name="contactName" />
          </Field>
          <Field name="contactEmail" v-slot="{ field }">
            <div class="uk-flex uk-margin-small-top">
              <FieldLabel title="問い合わせ先メールアドレス" :required="true" />
              <input class="uk-input uk-margin-small-left" type="text" v-bind="field" />
            </div>
            <FieldError name="contactEmail" />
          </Field>
        </div>
      </div>
      <div class="uk-modal-footer uk-text-right form-action">
        <div>
          <ActionButton title="戻る" class="uk-modal-close" toggleTarget=".position-form-modal" />
        </div>
        <div class="form-action-main">
          <ActionButton title="確定" color="primary" type="submit" :disabled="processing" />
        </div>
      </div>
    </Form>
  </div>
</template>
<style lang="scss" scoped>
@include modal-form;
div.uk-modal-dialog {
  width: unset;
}
textarea {
  resize: none;
  width: 100%;
}
input {
  width: 100%;
}
.legend {
  width: 100%;
  display: flex;
  align-items: center;
}
</style>
<script lang="ts">
import { Options } from "vue-class-component";
import { Prop } from "vue-property-decorator";
import FormMixin from "../../helpers/mixins/form";
import { LanguagesEnum, PrivacyPolicyResponse } from "../../autogen";
import { Field, Form } from "vee-validate";
import FieldLabel from "../atoms/FieldLabel.vue";
import * as yup from "yup";
import FieldError from "../atoms/FieldError.vue";
import FormError from "../atoms/FormError.vue";
import ActionButton from "@/components/atoms/ActionButton.vue";
import { SystemApi } from "../../autogen";

@Options({
  components: { Field, Form, FieldLabel, FieldError, ActionButton, FormError }
})
export default class PrivacyPolicyForm extends FormMixin {
  validationSchema!: yup.AnyObjectSchema;
  @Prop({ type: Object }) privacyPolicy: PrivacyPolicyResponse = {};
  @Prop({ type: String }) lang: keyof typeof LanguagesEnum = "ja";
  formName = "受検結果の閲覧範囲";

  get language() {
    return LanguagesEnum[this.lang];
  }
  beforeCreate() {
    this.validationSchema = yup.object({
      policy: yup.string().required(this.$t("input_required", { field: "受検結果の閲覧範囲" })),
      contactName: yup.string().required(this.$t("input_required", { field: "問い合わせ先" })),
      contactEmail: yup.string().required(this.$t("input_required", { field: "問い合わせ先メールアドレス" }))
    });
  }
  async onBeforeSubmit(privacyPolicy: PrivacyPolicyResponse) {
    this.formName = `閲覧範囲（${this.language}）`;
    await this.onSubmit(async () => {
      await new SystemApi().updatePrivacyPolicy({
        privacyPolicyRequest: {
          language: this.lang as string,
          policy: privacyPolicy.policy!,
          contactName: privacyPolicy.contactName!,
          contactEmail: privacyPolicy.contactEmail!
        }
      });
      this.$emit("submit");
    });
  }
}
</script>
